import React from "react";
import GridLayout from "../components/organisms/grid-layout/GridLayout";
import Layout from "../components/organisms/layout/layout";
import LibraryComponents from "../components/templates/library-components/libraryComponents";
import { ReferenciaOrganismos } from "../interfaces/ReferenciaOrganismos";
import { Link } from "gatsby";
import SEO from "../shared/seo";
import Button from "../components/atoms/button/button";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import Paginator from "../components/molecules/paginator/Paginator";

import "./styles/templateEdiciones.scss"

const TemplateEdiciones = (props: any) => {
  const pageData = props.pageContext.pageContent;
  const { slug, numPages, currentPage, elements } = props.pageContext;
  const keyName =
    pageData.referenciaCabecera && pageData.referenciaCabecera.tipoCabecera;
  const pageSlug = props.location.pathname;
  const compClass = "m-page-editions";
  
  return (
    <Layout
      hideHeaderDesktop={false}
      hideHeaderMobile={false}
      isNotRoot={true}
      headboard={pageData.referenciaCabecera}
      showPlayer={true}
    >
      <SEO
        title={
          props.pageContext.pageContent.titulo.split(">")[1] || props.pageContext.nombreCategoria
        }
        slug={pageSlug}
        description={
          props.pageContext.metaDescripcion &&
          props.pageContext.metaDescripcion.json.content[0].content[0].value
        }
        // image={
        //   props.pageContext.referenciaCabecera.imagenHeader &&
        //   props.pageContext.referenciaCabecera.imagenHeader.file.url
        // }
        lang="es"
      />
      {pageData.referenciaOrganismos &&
        pageData.referenciaOrganismos.map(
          (value: ReferenciaOrganismos, index: number) => (
            <div key={index} className={keyName} id={`${keyName}${index}`}>
              <LibraryComponents
                content={value}
                categoryName={pageData.nombreCategoria}
              />
            </div>
          )
        )}
      <GridLayout className="ediciones" columns="1fr" gap="0">
        {elements.map((edicion, key) => {
          return (
            <div className={`${compClass}__editions`} key={key}>
              <div className="m-page-editions__editions-container">
                <img
                  src={
                    edicion.referenciaInterna.referenciaCabecera.imagenHeader
                      .file.url
                  }
                  alt=""
                />
                <div className="m-page-editions__editions-content">
                  <h2>{edicion.nombreSubcategoria}</h2>
                  <h3>
                    {edicion.referenciaInterna.referenciaCabecera.tituloSpan}
                  </h3>
                  <p>
                    {
                      edicion.referenciaInterna.referenciaCabecera.descripcion
                        .json.content[0].content[0].value
                    }
                  </p>
                  <div className="m-page-editions__editions-content-actions">
                    <Link to={`${slug}${edicion.slug}`}>
                      <Button
                        type={"button"}
                        classname="main-button ver-historias"
                        text="Ver historias"
                        isDisabled={false}
                      />
                    </Link>
                    <Link to={`${edicion.link}`} target="_blank" rel="noreferrer">
                      <Button
                        type={"button"}
                        classname="main-button"
                        text="Ver en PDF"
                        isDisabled={!edicion.link ? true : false}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </GridLayout>
      <Paginator slug={slug} quantity={numPages} currentPage={currentPage} />
      <Disclaimer />
    </Layout>
  );
};

export default TemplateEdiciones;
